import { PixelData, imageDataToCanvas } from "@/core/utils/image-data"

export async function encodePNG(imageData: PixelData): Promise<Blob> {
	const canvas = await imageDataToCanvas(imageData)

	const blob = await canvas.convertToBlob({
		type: "image/png",
	})

	return blob
}
